import dayjs from 'dayjs'
import * as HandoverActions from '../actions/Handovers'
import { getJSON } from '../common/services/api'

export function fetchCurrentHandover() {
  return (dispatch) => {
    const url = `/api/list/handovers/current`
    return getJSON({ url })
      .then((res) => {
        dispatch(HandoverActions.setCurrentHandover(res.result))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function fetchHandoverHistory() {
  return (dispatch, getState) => {
    const { startDate, endDate } = getState().handovers.historyDateRange
    dispatch(HandoverActions.setHandoverHistory(null)) // show loading in history screen

    let url = `/api/list/handovers/history`
    if (startDate) {
      url += `?from=${startDate.toISOString()}`
      if (endDate) {
        url += `&to=${endDate.toISOString()}`
      }
    } else if (endDate) {
      url += `?to=${endDate.toISOString()}`
    } else {
      url += `?from=${dayjs().subtract(14, 'days').toISOString()}`
    }
    url += '&limit=50'
    return getJSON({ url })
      .then((res) => {
        dispatch(HandoverActions.setHandoverHistory(res.result))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function fetchHandoverHistoryItem(id) {
  return (dispatch) => {
    const url = `/api/list/handovers/${id}`
    return getJSON({ url })
      .then((res) => {
        dispatch(HandoverActions.setHandoverLogsAndNotes(res.result))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}
